import * as React from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import MobileStepper from "@mui/material/MobileStepper";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { AppBar, Divider, Stack } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

/* global localStorage sessionStorage */

const steps = [
  {
    label: "Accordor Template designer",
    description:
      "Accordor Template Designer is a design friendly, powerful, flexible Microsoft office web-based tools to design, and streamline your contract templates. It's required to maintain and manage agreement and clause templates. Template contains Merge fields, tables, clauses, conditions.",
  },
  {
    label: "New template",
    description:
      "New Template: Creating a new CLM Template with all the required information and stored in the Salesforce template object. Click on New template-> Enter the details->click on Save.",
  },
  {
    label: "Insert field",
    description:
      "Place the cursor in the template where you want to insert Salesforce Agreement and associated objects merge fields. Click on Insert field->Select the merge field->Insert.",
  },
  {
    label: "Insert table",
    description:
      "Related list to an Agreement object. field data populated in Rows and column. you can define conditions on rows and columns. Set the properties in Control Manager as Show header if true or hide header if false. Format:  show table captions and one empty row, To show captions only and no rows, To remove the entire table from the generated document. Click on Insert Table->Select related object-> Select fields (hold CTRL for multiple selection) and Insert Table.",
  },
  {
    label: "Mark condition",
    description:
      "for Field or Clause,Conditional logic can be used to control the display of field or clause are used in a template. Click on Mark conditions -> Mark field condition or Mark clause condition.",
  },
  {
    label: "Control manager",
    description:
      "Contains the information related with every field or clause in the template in the order. Some of the properties of field or table can be updated. Click on Control Manager.",
  },
  {
    label: "Check In template",
    description:
      "Once the template has all the required information including text, clauses, fields you will check it into the Salesforce template repository to use it for agreement generation. Click on Check in-> Fill the required info and Click on Check in.",
  },
  {
    label: "Check out template",
    description:
      "To choose a template document and click on Open to open in separate instance for locking and editing. Click on Check out->Select Template.",
  },
  {
    label: "Playbook",
    description:
      "Search for a template, clause that can be inserted or replaced selected text in the template. Search for the required type of clause you want to insert. Click on Playbook.",
  },
  {
    label: "Logout",
    description: "Logging out from the Accordor Template Designer.",
  },
];

export default function Firstrunexp(props: any) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = steps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const SkipFirstRunClick = () => {
    localStorage.setItem("skipfirstrun", "1");
    props.setSkipGet("1");
  };

  const SkipGettingStarted = () => {
    sessionStorage.setItem("skipfirstrun", "1");
    props.setSkipGet("1");
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button variant="outlined" endIcon={<KeyboardArrowRightIcon />} onClick={SkipFirstRunClick}>
          Skip
        </Button>
      </Box>
      <Divider sx={{ marginTop: 2 }} />
      <Paper
        square
        elevation={0}
        sx={{
          display: "flex",
          alignItems: "center",
          height: 50,
          pl: 2,
          bgcolor: "background.default",
        }}
      >
        <Typography variant="h6">{steps[activeStep].label}</Typography>
      </Paper>
      <Box sx={{ width: "100%", p: 2 }}>{steps[activeStep].description}</Box>
      <MobileStepper
        variant="text"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
            Next
            {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            Back
          </Button>
        }
      />
      <AppBar position="fixed" color="primary" sx={{ top: "auto", bottom: 0, bgcolor: "#1C39BB" }}>
        <Stack direction="row" spacing={2}>
          <Button variant="contained" size="small" type="submit" sx={{ width: "100%" }} onClick={SkipGettingStarted}>
            Getting Started
          </Button>
        </Stack>
      </AppBar>
    </Box>
  );
}
